export default __webpack_public_path__ + "/static/img/footer-logo.svg";